import React from 'react'
import {
  RENT_COMPS_PAGE_TITLE,
  SALES_COMPS_PAGE_TITLE
} from '@engine/dependencies/constants'
import { ReactComponent as SummaryLogo } from '@src/assets/summary_right_logo.svg'
import './PageTitleBar.scss'
import PropTypes from 'prop-types'

function PageTitleBar(props) {
  const { templateName, hasBranding, themeColors, hasPageTitle } = props

  return (
    <>
      {(hasPageTitle || hasBranding) && (
        <div className="property-rent-comps-heading barChart_pageTitle_height">
          <span className="compsTitle" style={{ color: themeColors.globalSubColor }} data-testid="comps-title">
            {hasPageTitle ? ((templateName?.includes('rentComps') || templateName?.includes('studentHousingComps'))
              ? RENT_COMPS_PAGE_TITLE
              : SALES_COMPS_PAGE_TITLE) : ''}
          </span>
          {hasBranding && (
            <SummaryLogo
              data-testid="logo-long"
              className="summary_logo"
            />
          )}
        </div>
      )}
    </>
  )
}

PageTitleBar.propTypes = {
  themeColors: PropTypes.object,
  templateName: PropTypes.string,
  hasBranding: PropTypes.bool,
  hasPageTitle: PropTypes.bool
}

export default PageTitleBar
